import React from 'react';
import styles from './style.module.css';
import StepOneForm from '../../components/forms/step-one';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Loan Intro Title</p>
        <h1 className={styles.mainTitle}>Type of Loan</h1>
        <p className={styles.text}>Content relating to the type of loan.</p>
        <StepOneForm />
    </div>
);
